export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-[420px] md:min-h-[600px] flex items-center bg-background-50 overflow-hidden"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-primary-50/50 via-background-50 to-accent-50/30"></div>

      <div className="relative z-10 w-full px-4 md:px-6 py-16 md:py-20">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-8 lg:gap-12">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 bg-primary-100/80 text-primary-700 px-3 py-1.5 rounded-full text-xs font-medium mb-5">
              <span className="w-1.5 h-1.5 rounded-full bg-primary-500 animate-pulse"></span>
              每日更新 · 实时跟进
            </div>

            <h1 className="font-heading text-2xl md:text-4xl lg:text-5xl font-bold text-foreground-950 leading-tight">
              51爆料网
              <span className="block text-primary-500 mt-1">黑料深扒 · 内幕汇总</span>
            </h1>

            <p className="mt-2 text-base md:text-lg text-foreground-600 font-heading">
              不放过每一个瓜，不遗漏每一条料
            </p>

            <p className="mt-5 text-sm md:text-base text-foreground-600 leading-relaxed max-w-xl mx-auto lg:mx-0">
              51爆料网是国内领先的黑料深扒与内幕消息聚合平台，聚焦51爆料黑料、51黑料爆料等热门话题。
              我们每日追踪明星网红黑历史、社会热点内幕与行业负面爆料，致力于为吃瓜群众提供最全面、最及时的黑料大全。
              黑料不打烊，深扒不停歇——这里是你获取一手内幕消息的首选入口。
            </p>

            <div className="mt-6 flex flex-wrap items-center gap-4 md:gap-6 justify-center lg:justify-start">
              <div className="flex items-center gap-2 text-sm text-foreground-600">
                <i className="ri-fire-line text-accent-500 text-lg"></i>
                <span>每日更新 <strong className="text-foreground-900">200+</strong> 条爆料</span>
              </div>
              <div className="flex items-center gap-2 text-sm text-foreground-600">
                <i className="ri-eye-line text-accent-500 text-lg"></i>
                <span>覆盖 <strong className="text-foreground-900">16个</strong> 话题分类</span>
              </div>
              <div className="flex items-center gap-2 text-sm text-foreground-600">
                <i className="ri-shield-check-line text-accent-500 text-lg"></i>
                <span>多方核实 <strong className="text-foreground-900">匿名</strong> 投稿保护</span>
              </div>
            </div>

            <div className="mt-7 flex flex-col sm:flex-row items-center gap-3 justify-center lg:justify-start">
              <a
                href="#cards"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 font-medium text-sm rounded-md hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-flashlight-line"></i>
                立即吃瓜
              </a>
              <a
                href="#contact"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#contact')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="inline-flex items-center gap-2 px-6 py-3 border border-foreground-300 text-foreground-700 font-medium text-sm rounded-md hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-mail-send-line"></i>
                我要爆料
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-md lg:max-w-lg mx-auto">
            <div className="relative w-full aspect-[4/3] md:aspect-[5/4] rounded-lg overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Dramatic%20editorial%20photography%20style%2C%20dark%20moody%20atmosphere%2C%20abstract%20representation%20of%20breaking%20news%20and%20investigative%20journalism%2C%20mysterious%20shadows%2C%20warm%20amber%20and%20deep%20crimson%20tones%2C%20cinematic%20lighting%2C%20blurred%20newspaper%20headlines%20in%20background%2C%20intense%20and%20provocative%20composition%2C%20no%20text%20visible%2C%20artistic%20conceptual%20photography&width=800&height=700&seq=hero-baoliao-main&orientation=portrait"
                alt="51爆料网 - 黑料深扒内幕汇总"
                title="51爆料网 - 黑料深扒内幕汇总"
                className="w-full h-full object-cover object-top rounded-lg"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/30 via-transparent to-transparent rounded-lg"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}